<template>
  <div>
    <Header />
    <div class="banners">
      <Banner :src="src" />
    </div>
    <div style="width: 70%; margin: 0 auto">
      <h2 style="margin-top: 20px; font-size: 24px; line-height: 60px">
        职位详情
      </h2>
      <div v-html="decDetail.bdContentcn" style="margin-top: 20px"></div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header.vue";
import Banner from "../../components/Banner.vue";
import Footer from "../../components/Footer.vue";
import Axios from "axios";
const Base64 = require("js-base64");
export default {
  components: { Header, Banner, Footer },
  data() {
    return {
      src: "",
      dec: "",
      decDetail: [],
    };
  },
  mounted() {
    Axios({
				url:'/apiv2/bdoc/getone?bdAtpid='+this.$route.query.detailText,
        data:{},
        method: 'GET',
			}).then((res) => {
				this.decDetail=res.data.data
				this.decDetail.bdContentcn=Base64.decode(this.decDetail.bdContentcn).replaceAll("<a","<a rel='noopener noreferrer'")
			})
    Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
      for (var i = 0; i < res.data.data.rows.length; i++) {
        if (res.data.data.rows[i].sc_key.slice(0, 13) == "JOINDETAILPIC") {
          this.src =
           res.data.data.rows[i].sc_value;
        }
      }
    })
  },
};
</script>
<style scoped>
::v-deep font{
	line-height: 40px;
}
::v-deep span{
	line-height: 40px;
}
::v-deep p{
	line-height: 40px;
}
</style>